import * as PIXI from 'pixi.js';
import { BubbleViewHandler } from '../BubbleViewHandler';
import { BubbleType } from '../../../bubbles/types';
import { IAnimation } from 'js/bubbleCore/view/animations/types';

export class FireViewHandler extends BubbleViewHandler<BubbleType.Fire> {
  public sprite: PIXI.Sprite | null = null;
  private fireSprites: IAnimation[] = [];

  public initView(): void {
    this.sprite = new PIXI.Sprite(PIXI.Texture.from('bubble_fire'));
    this.sprite.anchor.set(0.5);
    this.view.addChild(this.sprite);
    this.initFireParticle();
    this.initFireParticle();
    this.initFireParticle();
  }

  private initFireParticle(): void {
    const part = this.view.animationLayer.createFireParticle();
    this.view.addChild(part.root);
    this.fireSprites.push(part);
  }

  public async animateKill(): Promise<void> {
      
  }

  public cleanup(): void {
    if (this.sprite) {
      this.sprite.destroy();
      this.sprite = null;
    }

    this.fireSprites.forEach((sprite) => sprite.cancel());
  }
}